import { render, staticRenderFns } from "./DXTimeWorked.vue?vue&type=template&id=27a863d2&"
import script from "./DXTimeWorked.vue?vue&type=script&lang=js&"
export * from "./DXTimeWorked.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports